// import queue from 'async/queue';
import { apiSauce } from "../sagas/";
import store from "../reducers/";
import { path } from "ramda";
import ModalUtil from "../util/modal";
import OrganizationAction from "../reducers/OrganizationReducer";
import { isAlive } from "../util/index";
import I18n from "../i18n";
import Store, { ReducerKeys } from "../reducers";
import { buildDatePayload, fetchHandler, mergePayloadByFilter } from "../util/actions";
import { promises } from "fs";
// import { IndividualUserMockup } from "../_mockup/";

const getOrgByAdmin = ()=>new Promise((resolve,reject)=>{
	fetchHandler(apiSauce.getOrganizationByAdmin, ["data","data"], undefined, resolve, reject);
});

const uploadOrganizationBanner = (imageURI) => new Promise((resolve, reject) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const formData = new FormData();
	formData.append("image", imageURI);
	const packPayload = { headers: { token, organization: orgID}, payload: formData };
	apiSauce.uploadOrganizationBanner(packPayload).then(res => {
		const { data: {
			success,
			//data: { data }
		}, errors } = res;
		if (success) {
			store.dispatch(OrganizationAction.getOrganizationRequest());
			resolve(res);
		} else {
			reject(errors);
		}
	}).catch(reject);
});

const editOrganization = (payload = {}) => new Promise((resolve, reject) => {
	const { authen: { token }, organization: { organization: { name, description }, orgID } } = store.getState();
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		const packPayload = { headers: {token: token, organization : orgID }, payload: { name, description, ...payload } };
		apiSauce.editOrganization(packPayload).then(res => {
			const data = path(["data", "data"], res);
			if (res.ok && data) {
				ModalUtil.showSuccess("Updated successfully");
				store.dispatch(OrganizationAction.getOrganizationRequest());
				// store.dispatch(OrganizationAction.getOrganizationSuccess(data));

			} else {
				ModalUtil.showError(res);
			}
			// store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
			resolve(res);
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		reject(e);
	}
});

const addEmployee = (payload) => new Promise((resolve) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const packPayload = { headers: { token: token, organization: orgID }, payload };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.addEmployee(packPayload).then((res) => {
			const data = path(["data", "data"], res);
			if (res.ok && data) {
				ModalUtil.showSuccess("Created successfully");
				store.dispatch(OrganizationAction.fetchOrganizationLogsRequest());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const editEmployee = ({ payload, id }) => new Promise((resolve) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;

	const packPayload = { headers: { token: token, organization: orgID }, payload ,id};
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.editEmployee(packPayload).then((res) => {
			const data = path(["data", "data"], res);
			if (res.ok && data) {
				ModalUtil.showSuccess("Updated successfully");
				store.dispatch(OrganizationAction.fetchOrganizationLogsRequest());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const deleteEmployee = ({ id, reason }) => new Promise((resolve) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const packPayload = { headers: { token: token, organization: orgID }, id, payload: { reason } };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.deleteEmployee(packPayload).then((res) => {
			// console.log(res);
			if (res.ok) {
				ModalUtil.showSuccess("Deleted successfully");
				store.dispatch(OrganizationAction.fetchOrganizationLogsRequest());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const deleteMutiEmployee = (payload) => new Promise(resolve => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
	try {
		apiSauce.massDeleteEmployee({ payload, headers: { token: token, organization: orgID } }).then((res) => {
			if (res.ok) {
				ModalUtil.showSuccess("Deleted successfully");
				store.dispatch(OrganizationAction.fetchOrganizationLogsRequest());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const disableEmployee = ({ id, reason }) => new Promise((resolve) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const packPayload = { headers: { token: token, organization: orgID } , id, payload: { reason } };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.disableEmployee(packPayload).then((res) => {
			// console.log(res);
			if (res.ok) {
				ModalUtil.showSuccess("Deleted successfully");
				store.dispatch(OrganizationAction.fetchOrganizationLogsRequest());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const disableMutiEmployee = (payload) => new Promise(resolve => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
	try {
		apiSauce.massDisableEmployee({ payload, headers: { token: token, organization: orgID }  }).then((res) => {
			if (res.ok) {
				ModalUtil.showSuccess("Deleted successfully");
				store.dispatch(OrganizationAction.fetchOrganizationLogsRequest());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const importEmployees = (payload, importMode) => new Promise((resolve) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;

	const body = new FormData();
	body.append("import", payload);
	body.append("delete_absent_employees", importMode === "replace_all" ? 1 : 0 );
	const packPayload = { headers: {token, organization :orgID }, payload: body };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.importEmployees(packPayload).then(res => {
			if (res.ok && res.data && res.data.success) {
				ModalUtil.showSuccess("Imported successfully");
				store.dispatch(OrganizationAction.fetchOrganizationLogsRequest());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const deleteOrganizationCategory = (id) => new Promise((resolve) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const packPayload = { headers : { token, organization : orgID }, id };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.deleteOrganizationCategory(packPayload).then((res) => {
			const data = path(["data", "data"], res);
			if (res.ok) {
				ModalUtil.showSuccess("Deleted successfully");
				store.dispatch(OrganizationAction.getOrganizationRequest());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

/**
 * Grant an admin role to employees.
 * @param {array} employee_emails
 * @param {boolean} autoFetchAdmin
 */
const addAdmins = (employee_emails, autoFetchAdmin = false) => new Promise((resolve, reject) => {
	const token = path([ReducerKeys.AUTHEN, "token"], Store.getState());
	const { orgID } = store.getState().organization;
	const queue = employee_emails.slice();
	const caller = (res) => {
		if (res === undefined || res.status === 200) {
			if (queue.length === 0) {
				if (autoFetchAdmin) {
					ModalUtil.showSuccess(I18n.t("add_admin_success"));
					Store.dispatch(OrganizationAction.getAllAdminsRequest());
				}
				resolve(res);
			} else {
				const target = queue.shift();
				const payload = { email: target };
				apiSauce.addAdmin({ headers: {token , organization : orgID }, payload })
					.then(caller)
					.catch(error => {
						ModalUtil.showDefaultError();
						reject(error);
					});
			}
		} else if (isAlive(res)) {
			ModalUtil.showDefaultError();
			reject(res);
		}
	};
	caller();
});
/**
 * Revoke an admin roles from employees.
 * @param {array} user_ids
 * @param {boolean} autoFetchEmployee
 */
const deleteAdmins = (user_ids, autoFetchEmployee = false) => new Promise((resolve, reject) => {
	const token = path([ReducerKeys.AUTHEN, "token"], Store.getState());
	const orgID = path([ReducerKeys.ORGANIZATION, "orgID"], Store.getState());

	const queue = user_ids.slice();
	const caller = (res) => {
		if (res === undefined || res.ok) {
			if (queue.length === 0) {
				if (autoFetchEmployee) {
					ModalUtil.showSuccess(I18n.t("add_admin_success"));
				}
				resolve(res);
			} else {
				const userid = queue.shift();
				apiSauce.deleteAdmin({ headers: { token, organization: orgID}, userid })
					.then(caller)
					.catch(error => {
						ModalUtil.showDefaultError();
						reject(error);
					});
			}
		} else if (isAlive(res)) {
			ModalUtil.showDefaultError();
			reject(res);
		}
	};
	caller();
});
const fetchAdmin = () => new Promise((resolve, reject) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	// Add fetch admin
	apiSauce.fetchAdmin({ headers: { token, organization: orgID }}).then(res => {
		if (res.ok) {
			Store.dispatch(OrganizationAction.getAllAdminsSuccess(res.data.data));
			resolve(res.data.data);
		} else {
			Store.dispatch(OrganizationAction.getAllAdminsFailure());
			reject(res);
		}
	}).catch(reject);
});

const addOrganizationCategoryChoice = ({ id, payload }) => new Promise(resolve => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;

	const packPayload = { headers: { token, organization: orgID }, id, payload };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.addOrganizationCategoryChoice(packPayload).then((res) => {
			const data = path(["data", "data"], res);
			if (res.ok && data) {
				ModalUtil.showSuccess("Created successfully");
				store.dispatch(OrganizationAction.fetchOrganizationLogsRequest());
				store.dispatch(OrganizationAction.getOrganizationRequest());
				// store.dispatch(OrganizationAction.getOrganizationSuccess(data));
			} else {
				ModalUtil.showError(res);
				resolve(false);
			}
			// store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
			resolve(true);

		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const editOrganizationCategoryChoice = ({ id, payload }) => new Promise(resolve => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const packPayload = { headers : {token, organization : orgID}, id, payload };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.editOrganizationCategoryChoice(packPayload).then((res) => {
			const data = path(["data", "data"], res);
			// console.log(res);
			if (res.ok && data) {
				ModalUtil.showSuccess("Updated successfully");
				store.dispatch(OrganizationAction.getOrganizationRequest());
				// store.dispatch(OrganizationAction.getOrganizationSuccess(data));
				store.dispatch(OrganizationAction.fetchOrganizationLogsRequest());
				resolve(false);

			} else {
				ModalUtil.showError(res);
			}
			store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
			resolve(res);
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});
const sendInviteToEmployees = (employee_ids, language="en") => new Promise((resolve, reject) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;

	const payload = { employee_ids, language };
	const packPayload = { headers: { token, organization: orgID }, payload };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.sendInviteToEmployees(packPayload).then((res) => {
			if (res.ok) {
				ModalUtil.showSuccess(I18n.t("send_invitation_email_success"));
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});
const sendInviteToAllEmployees = (language="en") => new Promise((resolve, reject) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;

	const payload = { language };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.sendInviteToAllEmployees({ headers : {token, organization : orgID}, payload }).then((res) => {
			if (res.ok) {
				ModalUtil.showSuccess(I18n.t("send_invitation_email_success"));
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});
const sendStressTestInvite = (employee_ids, language="en") => new Promise((resolve, reject) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const payload = { employee_ids, language };
	const packPayload = { headers: { token, organization: orgID }, payload };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.sendStressTestInvite(packPayload).then((res) => {
			if (res.ok) {
				ModalUtil.showSuccess(I18n.t("send_invitation_email_success"));
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});
const sendStressTestInviteToAll = (language="en") => new Promise((resolve, reject) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const payload = { action: 'all', language };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.sendStressTestInviteToAll({ headers: { token, organization: orgID }, payload }).then((res) => {
			if (res.ok) {
				ModalUtil.showSuccess(I18n.t("send_invitation_email_success"));
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const sendStressTestInviteToRegistered = (language="en") => new Promise((resolve, reject) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const payload = { action: 'registered', language };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.sendStressTestInviteToRegistered({ headers: { token, organization: orgID }, payload }).then((res) => {
			if (res.ok) {
				ModalUtil.showSuccess(I18n.t("send_invitation_email_success"));
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const sendStressTestInviteToNotRegistered = (language="en") => new Promise((resolve, reject) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	const payload = { action: 'not-registered', language };
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce.sendStressTestInviteToNotRegistered({ headers: { token, organization: orgID }, payload }).then((res) => {
			if (res.ok) {
				ModalUtil.showSuccess(I18n.t("send_invitation_email_success"));
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(true);
			} else {
				ModalUtil.showError(res);
				store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve(false);
	}
});

const getEmployees = (option) => new Promise((resolve, reject) => {
	const { token } = store.getState().authen;
	const { orgID } = store.getState().organization;
	let packOption = "";
	Object.keys(option).map((value, index) => {
		if (option[value]) packOption += `${value}=${option[value]}`;
		if (Object.keys(option).length - 1 != index && option[Object.keys(option)[index + 1]]) packOption += "&";
	});
	try {
		store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		apiSauce
			.getEmployees({
				headers: { token, organization: orgID },
				option: packOption
			})
			.then(res => {
				if (res.ok) {
					const employees = path(["data", "data"], res);
					const { pagination, active_employees } = path(
						["data", "meta"],
						res
					);
					const packRes = { employees };
					if (pagination) packRes.pagination = pagination;
					if (active_employees) packRes.active_employees = active_employees;
					store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
					resolve(packRes);
				} else {
					ModalUtil.showError(res);
					store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
					resolve(false);
				}
			});
	} catch (e) {
		ModalUtil.showDefaultError();
		store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		resolve();
	}
});
const getFilterEmployees = (dateRange, filters, option, errorOnInfo, caller)=>new Promise((resolve, reject) => {
	let withEmailFilter = filters.slice(0);
	if(option.search){
		withEmailFilter.push({key:"email",value:option.search});
	}
	let payload = buildDatePayload(dateRange);
	payload = mergePayloadByFilter(payload, withEmailFilter);
	let packOption = "";
	Object.keys(option).map((value, index) => {
		if (option[value]) packOption += `${value}=${option[value]}`;
		if (Object.keys(option).length - 1 != index && option[Object.keys(option)[index + 1]]) packOption += "&";
	});
	const payloadMod = (packPayload)=>({...packPayload, option: packOption});
	fetchHandler(caller, ["data"], payload, (res)=>{
		const { data, meta } =res;
		const employees = data;
		const { pagination, active_employees } = meta;
		const packRes = { employees };
		if (pagination) packRes.pagination = pagination;
		if (active_employees) packRes.active_employees = active_employees;
		resolve(packRes);
	}, reject, errorOnInfo, { payloadMod });
});
const getStressFilterEmployees = ({dateRange, filters, option, errorOnInfo})=>(
	getFilterEmployees(dateRange, filters, option, errorOnInfo, apiSauce.fetchStressIndividualByFilter)
);
const getCounFilterEmployees = ({dateRange, filters, option, errorOnInfo})=>(
	getFilterEmployees(dateRange, filters, option, errorOnInfo, apiSauce.fetchCounIndividualByFilter)
);
export {
	getOrgByAdmin,
	uploadOrganizationBanner, editOrganization,
	addEmployee, editEmployee, deleteEmployee,
	importEmployees,
	deleteOrganizationCategory,
	addAdmins, deleteAdmins,
	fetchAdmin,
	//fetchAllAdminAndEmployees,
	addOrganizationCategoryChoice,
	editOrganizationCategoryChoice,
	sendInviteToEmployees,
	sendStressTestInvite,
	sendInviteToAllEmployees,
	sendStressTestInviteToAll,
	sendStressTestInviteToRegistered,
	sendStressTestInviteToNotRegistered,
	getEmployees,
	deleteMutiEmployee,
	disableEmployee,
	disableMutiEmployee,

	getStressFilterEmployees,
	getCounFilterEmployees
};



// WEBPACK FOOTER //
// ./src/actions/OrganizationAction.js